import { render, staticRenderFns } from "./InventoryBooking.vue?vue&type=template&id=62951c8a&scoped=true"
import script from "./InventoryBooking.vue?vue&type=script&lang=js"
export * from "./InventoryBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62951c8a",
  null
  
)

export default component.exports